import { FaExclamationCircle } from '@react-icons/all-files/fa/FaExclamationCircle';
import { FaRegQuestionCircle } from '@react-icons/all-files/fa/FaRegQuestionCircle';
import { FaAngleUp } from '@react-icons/all-files/fa/FaAngleUp';
import { FaAngleDown } from '@react-icons/all-files/fa/FaAngleDown';
import { FaExchangeAlt } from '@react-icons/all-files/fa/FaExchangeAlt';
import { FaExclamationTriangle } from '@react-icons/all-files/fa/FaExclamationTriangle';
import { FaSearch } from '@react-icons/all-files/fa/FaSearch';
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight';
import { FaDiscord } from '@react-icons/all-files/fa/FaDiscord';
import { FaTelegramPlane } from '@react-icons/all-files/fa/FaTelegramPlane';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';

import { FiChevronDown } from '@react-icons/all-files/fi/FiChevronDown';
import { FiChevronRight } from '@react-icons/all-files/fi/FiChevronRight';
import { FiSearch } from '@react-icons/all-files/fi/FiSearch';

import { HiOutlineExternalLink } from '@react-icons/all-files/hi/HiOutlineExternalLink';
import { HiDownload } from '@react-icons/all-files/hi/HiDownload';

import { AiOutlineMedium } from '@react-icons/all-files/ai/AiOutlineMedium';
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose';
import { AiFillCloseCircle } from '@react-icons/all-files/ai/AiFillCloseCircle';
import { AiOutlineCheck } from '@react-icons/all-files/ai/AiOutlineCheck';
import { AiFillStar } from '@react-icons/all-files/ai/AiFillStar';

import { RiArrowRightSLine } from '@react-icons/all-files/ri/RiArrowRightSLine';
import { RiArrowDownSFill } from '@react-icons/all-files/ri/RiArrowDownSFill';
import { RiLogoutCircleRLine } from '@react-icons/all-files/ri/RiLogoutCircleRLine';
import { RiArrowLeftSLine } from '@react-icons/all-files/ri/RiArrowLeftSLine';

import { MdArrowDropDown } from '@react-icons/all-files/md/MdArrowDropDown';
import { MdArrowDropUp } from '@react-icons/all-files/md/MdArrowDropUp';
// import { MdOutlineRefresh } from '@react-icons/all-files/md/MdOutlineRefresh';
import { MdRefresh } from '@react-icons/all-files/md/MdRefresh';
import { MdKeyboardArrowDown } from '@react-icons/all-files/md/MdKeyboardArrowDown';

import { IoIosClose } from '@react-icons/all-files/io/IoIosClose';
import { IoIosArrowDown } from '@react-icons/all-files/io/IoIosArrowDown';
import { IoIosArrowUp } from '@react-icons/all-files/io/IoIosArrowUp';
import { IoMdArrowDropdown } from '@react-icons/all-files/io/IoMdArrowDropdown';
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';

import { IoArrowDownOutline } from '@react-icons/all-files/io5/IoArrowDownOutline';
import { IoArrowUpOutline } from '@react-icons/all-files/io5/IoArrowUpOutline';
import { IoCloseSharp } from '@react-icons/all-files/io5/IoCloseSharp';
import { IoClose } from '@react-icons/all-files/io5/IoClose';
import { IoCloseOutline } from '@react-icons/all-files/io5/IoCloseOutline';
import { IoWarning } from '@react-icons/all-files/io5/IoWarning';
import { IoChevronBack } from '@react-icons/all-files/io5/IoChevronBack';

import { BsArrowUpRight } from '@react-icons/all-files/bs/BsArrowUpRight';
import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import { BsCheckCircle } from '@react-icons/all-files/bs/BsCheckCircle';

import { TiArrowSortedUp } from '@react-icons/all-files/ti/TiArrowSortedUp';

import { BiCopy } from '@react-icons/all-files/bi/BiCopy';

// all-files missing icons
const MdOutlineRefresh = MdRefresh;

export {
  //fa
  FaExclamationCircle,
  FaRegQuestionCircle,
  FaSearch,
  FaCheck,
  FaAngleUp,
  FaAngleDown,
  FaAngleRight,
  FaExchangeAlt,
  FaExclamationTriangle,
  FaDiscord,
  FaTelegramPlane,
  FaTwitter,
  //fi
  FiChevronDown,
  FiChevronRight,
  FiSearch,
  // hi
  HiOutlineExternalLink,
  HiDownload,
  // ai
  AiOutlineMedium,
  AiOutlineClose,
  AiFillCloseCircle,
  AiOutlineCheck,
  AiFillStar,
  //ri
  RiArrowRightSLine,
  RiArrowDownSFill,
  RiLogoutCircleRLine,
  RiArrowLeftSLine,
  // md
  MdArrowDropUp,
  MdArrowDropDown,
  MdOutlineRefresh,
  MdKeyboardArrowDown,
  //io
  IoIosClose,
  IoMdArrowDropdown,
  IoIosArrowDown,
  IoIosArrowUp,
  IoMdClose,
  //io5
  IoClose,
  IoArrowDownOutline,
  IoArrowUpOutline,
  IoCloseSharp,
  IoCloseOutline,
  IoWarning,
  IoChevronBack,
  //bs
  BsArrowUpRight,
  BsArrowRight,
  BsCheckCircle,
  //ti
  TiArrowSortedUp,
  //bi
  BiCopy,
};
